<template>
    <div v-if="visible" class="quota-banner" :class="`quota-banner--${status}`">
        <div class="quota-icon">
            <v-icon size="18">mdi-alert-circle-outline</v-icon>
        </div>
        <div class="quota-text">
            <span class="quota-title">{{ title }}</span>
            <span class="quota-sub">{{ subtitle }}</span>
        </div>
    </div>
</template>

<script>
import { daysUntilPayment, paymentStatus } from "@/utils/Business";

export default {
    name: "QuotaBanner",
    props: {
        client: {
            type: Object,
            default: null,
        },
    },
    computed: {
        status(vm = this) {
            return paymentStatus(vm.client)
        },
        days(vm = this) {
            return daysUntilPayment(vm.client)
        },
        // Solo avisa cuando falta poco o ya vencio: un aviso permanente de plata
        // que no tiene nada para decir es ruido.
        visible(vm = this) {
            return ['due', 'overdue'].includes(vm.status)
        },
        title(vm = this) {
            if (vm.status === 'overdue') return vm.$t('business.quota_overdue')
            if (vm.days === 0) return vm.$t('business.quota_due_today')
            return vm.$tc('business.quota_due_days', vm.days, { n: vm.days })
        },
        subtitle(vm = this) {
            if (vm.status !== 'overdue') return vm.$t('business.quota_banner_sub')
            const days = Math.abs(vm.days)
            if (days === 0) return vm.$t('business.quota_banner_sub')
            return `${vm.$tc('business.quota_overdue_days', days, { n: days })} · ${vm.$t('business.quota_banner_sub')}`
        },
    },
}
</script>

<style scoped>
.quota-banner {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 14px;
}

.quota-banner--due {
    background: rgba(230, 172, 0, 0.1);
    border: 1px solid rgba(230, 172, 0, 0.3);
}

.quota-banner--overdue {
    background: rgba(232, 92, 92, 0.1);
    border: 1px solid rgba(232, 92, 92, 0.3);
}

.quota-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 10px;
}

.quota-banner--due .quota-icon {
    background: rgba(230, 172, 0, 0.18);
}

.quota-banner--overdue .quota-icon {
    background: rgba(232, 92, 92, 0.18);
}

.quota-banner--due .quota-icon .v-icon {
    color: #E6AC00;
}

.quota-banner--overdue .quota-icon .v-icon {
    color: var(--v-error-base);
}

.quota-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.quota-title {
    font-size: var(--fs-label);
    font-weight: 700;
}

.quota-banner--due .quota-title {
    color: #E6AC00;
}

.quota-banner--overdue .quota-title {
    color: var(--v-error-base);
}

.quota-sub {
    margin-top: 1px;
    font-size: var(--fs-caption);
    color: var(--v-txtSecondary-base);
}

.theme--light .quota-banner--due .quota-title {
    color: #B8860B;
}
</style>
